import { render } from "./ContentsDetailComponent.vue?vue&type=template&id=6fe01fba&scoped=true&ts=true"
import script from "./ContentsDetailComponent.vue?vue&type=script&lang=ts"
export * from "./ContentsDetailComponent.vue?vue&type=script&lang=ts"

import "./ContentsDetailComponent.vue?vue&type=style&index=0&id=6fe01fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe01fba"]])

export default __exports__